import 'twin.macro';

import React from 'react';
import { useEffect } from 'react';
import { useContext } from 'react';
import { useLocation } from 'react-router-dom';

import { ThemeContext } from '@/contexts/theme-context';
import LandingInfoBanner from '@/views/landing-deposit/landing-info-banner';
import LandingInvestBanner from '@/views/landing-invest/invest-banner';
import LandingInvestBenefits from '@/views/landing-invest/invest-benefits';
import LandingInvestConditions from '@/views/landing-invest/invest-conditions';
import InvestHowItWorks from '@/views/landing-invest/invest-how-it-works';
import LandingInvestQA from '@/views/landing-invest/landing-invest-qa';
import LandingInvestReplenish from '@/views/landing-invest/landing-invest-replenish';
import LandingInvestWithdaw from '@/views/landing-invest/landing-invest-withdaw';

function LandingInvest() {
  const { theme, setTheme } = useContext(ThemeContext);

  const location = useLocation();
  useEffect(() => {
    window.scrollTo(0, 0);
  }, [location]);
  useEffect(() => {
    setTheme('dark');
  }, [setTheme]);
  return (
    <>
      <LandingInvestBanner />
      <LandingInvestBenefits />
      <InvestHowItWorks />
      <LandingInvestReplenish />
      <LandingInvestWithdaw />
      <LandingInvestConditions />
      <LandingInvestQA />
      <LandingInfoBanner />
    </>
  );
}

export default LandingInvest;
